import { render, staticRenderFns } from "./Ekyc.vue?vue&type=template&id=42ccba0c&"
import script from "./Ekyc.vue?vue&type=script&lang=js&"
export * from "./Ekyc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports